import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { postApiFormData } from "../helpers/AxiosInstance";

interface IUsePostFormDataHook {
  queryKey: string[];
  showSuccessToast?: boolean;
  showErrorToast?: boolean;
}

const usePostFormDataHook = (props: IUsePostFormDataHook) => {
  const { queryKey, showSuccessToast = true, showErrorToast = true } = props;
  const queryClient = useQueryClient();

  const {
    isPending: isPostLoading,
    mutateAsync,
    isSuccess: isPostSuccess,
    data: postData,
    isError: isPostError,
  } = useMutation({
    mutationFn: postApiFormData,
    onSuccess: async (data) => {      
      if (data?.status === 201 || data?.status === 200) {
        if (showSuccessToast) {
          toast.success(data?.data?.message ?? "File Uploaded Successfully");
        }
      } else {
        if (showErrorToast) {
          if (data?.data?.non_field_errors) {
            toast.error(data?.data?.non_field_errors[0]);
          } else {
            toast.error(data?.data?.message ?? "Something went wrong");
          }
        }
      }
    },
    onError: (error) => {
      if (showErrorToast) {
        toast.error("Error");
      }
    },
    onSettled: async () => {
      queryClient.invalidateQueries({
        queryKey: queryKey,
        refetchType: "active",
      });
    },
  });

  return {
    isPostLoading,
    mutateAsync,
    isPostSuccess,
    postData,
    isPostError,
  };
};

export default usePostFormDataHook;